import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useIsMobile from '../../hooks/useIsMobile';
import { card, cardHover, colors, motion, space, type } from '../../styles/tokens';

const ProjectCard = ({
  title,
  tech,
  description,
  showLink = false,
  link,
  caseStudyId,
  note
}) => {
  const [hovered, setHovered] = useState(false);
  const isMobile = useIsMobile();

  const arrow = {
    display: 'inline-block',
    transition: `transform ${motion.fast} ease`,
    transform: hovered ? 'translateX(3px)' : 'translateX(0)'
  };

  return (
    <div
      style={{
        ...card,
        ...(hovered ? cardHover : {}),
        padding: isMobile ? space[3] : space[4],
        marginBottom: space[3]
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          gap: space[2],
          marginBottom: space[2],
          flexWrap: 'wrap'
        }}
      >
        <h3 style={type.h3}>{title}</h3>
        <span style={type.meta}>{tech}</span>
      </div>

      <p style={{ ...type.body, marginBottom: space[3], whiteSpace: 'pre-line' }}>
        {description}
      </p>

      {(showLink || caseStudyId || note) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: space[3], flexWrap: 'wrap' }}>
          {showLink && (
            <a href={link} target="_blank" rel="noopener noreferrer" style={type.link}>
              View project <span style={arrow}>→</span>
            </a>
          )}
          {caseStudyId && (
            <Link to={`/case-studies/${caseStudyId}`} style={type.link}>
              See case study <span style={arrow}>→</span>
            </Link>
          )}
          {note && (
            <span style={{ ...type.link, color: colors.sageLight }}>{note} ✦</span>
          )}
        </div>
      )}
    </div>
  );
};

export default ProjectCard;
